module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-kpito-01.8b9203fd.jpg";